document.addEventListener("DOMContentLoaded", function() {
  var menuItems = document.querySelectorAll('.menu-item.has-dropdown, .has-sub-dropdown');

  menuItems.forEach(function(item) {
    item.addEventListener('click', function(event) {
      event.stopPropagation();
      item.classList.toggle('active');
      var allSubMenus = document.querySelectorAll('.menu-item.has-dropdown.active, .has-sub-dropdown.active');
      allSubMenus.forEach(function(subMenu) {
        if (subMenu !== item) {
          subMenu.classList.remove('active');
        }
      });
    });
  });
  document.addEventListener('click', function() {
    var allSubMenus = document.querySelectorAll('.menu-item.has-dropdown.active, .has-sub-dropdown.active');
    allSubMenus.forEach(function(subMenu) {
      subMenu.classList.remove('active');
    });
  });
});
